import { BottomFooterRoutes } from "../../components/shared/footer/BottomFooter";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { User, RouteVariable, RouteOutput, Area } from "../../types/types";
import { ToGraphqlVariable } from "../routes";
import { TopFooterRoutes } from "../../components/shared";
import * as Immutable from 'immutable'
import { Connection } from "../graphql";

type QueryVariables = {
  topFooterRoutes: RouteVariable<TopFooterRoutes>[]
  bottomFooterRoutes: RouteVariable<BottomFooterRoutes>[]
  areaset: 'footer'
}


type QueryResult = {
  topFooterRoutes: RouteOutput<TopFooterRoutes>[]
  bottomFooterRoutes: RouteOutput<BottomFooterRoutes>[]
  siteSettings: {
    recaptchakey:string
  }
  highlighted_areas: Connection<Area>
}

export class FooterQuery extends Query<QueryResult, QueryVariables> { }

export const query = () => {
  return gql`
    query Footer($areaset: AreaSet!, $topFooterRoutes: [RouteInput!]!, $bottomFooterRoutes: [RouteInput!]!) {
      bottomFooterRoutes: routes(routes: $bottomFooterRoutes) {
        url
        path
        name
        identifier
      },
      topFooterRoutes: routes(routes: $topFooterRoutes) {
        url
        path
        name
        identifier
      },
      siteSettings {
        recaptchakey
      },
      highlighted_areas: areaSet(set: $areaset, first:6) {
        edges {
          node {
            id
            name
            path
          }
          cursor
        }
      }
    }
  `
}

const TopFooterRoutesVariables = () : RouteVariable<TopFooterRoutes>[] => ToGraphqlVariable<TopFooterRoutes>({
  boolean_gites: { "name": "boolean_gites" },
  boolean_bed_and_breakfasts: { "name": "boolean_bed_and_breakfasts" },
  boolean_sale_adverts: { "name": "boolean_sale_adverts" },
  themes: { "name": "themes" },
  areas: { "name": "areas" },
  boolean_gites_swimmingpool: { "name": "boolean_gites", "args": { "booleans": "has_swimmingpool"} },
  boolean_gites_sea: { "name": "boolean_gites", "args": { "booleans": ["languedoc-roussillon", "provence-alpes-cotedazur"] } },
  boolean_gites_beach: { "name": "boolean_gites", "args": { "booleans": "near_beach" } },
  boolean_gites_watersports: { "name": "boolean_gites", "args": { "booleans": "near_watersports" } },
  lastminutes: { "name": "boolean_gites", "args":{"booleans":["last_minute"]}},
  boolean_bed_and_breakfasts_swimmingpool: { "name": "boolean_bed_and_breakfasts", "args": {"booleans": "has_swimmingpool"} },
  boolean_bed_and_breakfasts_skiing: { "name": "boolean_bed_and_breakfasts", "args": {"booleans": "near_skiing"} },
  boolean_sale_adverts_swimmingpool: { "name": "boolean_sale_adverts", "args": { "booleans": "has_swimmingpool" } },
  boolean_sale_adverts_commerce: { "name": "boolean_sale_adverts",  "args": { "booleans": "commerce" } },
  dutch_root: { "name": "root", "locale": "nl" },
  english_root: { "name": "root", "locale": "en" },
  french_root: { "name": "root", "locale": "fr" },
  german_root: { "name": "root", "locale": "de" },
})


const BottomFooterRoutesVariables = (user: User) : RouteVariable<BottomFooterRoutes>[] => {

  return ToGraphqlVariable<BottomFooterRoutes>({
    advertise_url: { "name": "advertise" },
    about_url: { "name": "about" },
    destroy_user_session_url: user ? { "name": "destroy_user_session" } : null,
    disclaimer_url: { "name": "page", "args":{ "slug": "disclaimer" } },
    terms_and_conditions_url: { "name": "page", "args":{ "slug": "terms_and_conditions" } },
    new_newsletter_url: { "name": "new_newsletter" },
    superadmin_root_url: user && user.role == 'admin' ? { "name": "superadmin_root" } : null,
    admin_user_adverts_url: user ? { "name": "admin_user_adverts", "args":{ "user_id": user.id } } : null,
    edit_user_url: user ? { "name": "edit_user", "args":{ "id": user.id, upgrade: 'true' }  } : null,
    new_user_session_url: !user ? { "name": "new_user_session" } : null,
    new_user_registration_url: !user ? { "name": "new_user_registration" } : null,
  })
}

export const variables = (user: User) : QueryVariables => {
  return {
    topFooterRoutes: TopFooterRoutesVariables(),
    bottomFooterRoutes: BottomFooterRoutesVariables(user),
    areaset: 'footer'
  }
}
